module.exports = __webpack_public_path__ + "img/CommentIcon.d7735bdb.svg";